/* =========================================================
   ALTAR DE LOS PELUDOS · Puromenu · Halloween 2026
   Motor del altar interactivo: carga de datos (Supabase),
   mural con zoom/arrastre, ficha, velas, reportes, buscador
   y enlace directo (?peludo=ID).
   Solo actúa sobre elementos [data-pma-altar].
   ========================================================= */
(function () {
  'use strict';
  if (window.PMAltarLoaded) return;
  window.PMAltarLoaded = true;

  var CELL_W = 190;
  var CELL_H = 230;
  var FRAME_W = 150;
  var FRAME_H = 200;
  var MIN_RINGS = 3;
  var MAX_SCALE = 3;
  var DRAG_THRESHOLD = 6;

  /* ---------- Ilustraciones por defecto (se sustituyen por imágenes del Customizer) ---------- */
  var SVG = {
    velas: '<svg viewBox="0 0 110 120" width="110" height="120" aria-hidden="true"><circle cx="30" cy="42" r="24" fill="#F7941D" opacity="0.18"/><circle cx="56" cy="27" r="26" fill="#F7941D" opacity="0.2"/><circle cx="81" cy="50" r="22" fill="#F7941D" opacity="0.18"/><rect x="20" y="52" width="20" height="60" rx="3" fill="#FFF4E2"/><rect x="20" y="78" width="20" height="8" fill="#E4007C"/><rect x="45" y="37" width="22" height="75" rx="3" fill="#FFF4E2"/><rect x="45" y="70" width="22" height="8" fill="#00A3A1"/><rect x="72" y="60" width="18" height="52" rx="3" fill="#FFF4E2"/><rect x="72" y="84" width="18" height="8" fill="#7B2D8E"/><path d="M30 34c4 5 5 8 5 10a5 5 0 0 1-10 0c0-2 1-5 5-10z" fill="#FFB000"/><path d="M56 18c4.5 5.5 5.5 8.5 5.5 10.5a5.5 5.5 0 0 1-11 0c0-2 1-5 5.5-10.5z" fill="#FFB000"/><path d="M81 42c4 5 5 8 5 10a5 5 0 0 1-10 0c0-2 1-5 5-10z" fill="#FFB000"/></svg>',
    vela: '<svg viewBox="0 0 110 120" width="90" height="98" aria-hidden="true"><circle cx="40" cy="42" r="24" fill="#F7941D" opacity="0.22"/><circle cx="66" cy="27" r="26" fill="#F7941D" opacity="0.24"/><rect x="30" y="52" width="20" height="60" rx="3" fill="#FFF4E2"/><rect x="30" y="78" width="20" height="8" fill="#E4007C"/><rect x="55" y="37" width="22" height="75" rx="3" fill="#FFF4E2"/><rect x="55" y="70" width="22" height="8" fill="#00A3A1"/><path d="M40 34c4 5 5 8 5 10a5 5 0 0 1-10 0c0-2 1-5 5-10z" fill="#FFB000"/><path d="M66 18c4.5 5.5 5.5 8.5 5.5 10.5a5.5 5.5 0 0 1-11 0c0-2 1-5 5.5-10.5z" fill="#FFB000"/></svg>',
    flores: '<svg viewBox="0 0 110 110" width="110" height="110" aria-hidden="true"><ellipse cx="22" cy="82" rx="16" ry="7" fill="#3E8E41" transform="rotate(-30 22 82)"/><ellipse cx="88" cy="80" rx="16" ry="7" fill="#3E8E41" transform="rotate(30 88 80)"/><circle cx="36" cy="58" r="19" fill="#F7941D"/><circle cx="66" cy="46" r="21" fill="#FFB000"/><circle cx="80" cy="76" r="17" fill="#F7941D"/><circle cx="46" cy="86" r="16" fill="#FFB000"/><circle cx="36" cy="58" r="6" fill="#D9600B"/><circle cx="66" cy="46" r="7" fill="#D9600B"/><circle cx="80" cy="76" r="5" fill="#D9600B"/><circle cx="46" cy="86" r="5" fill="#D9600B"/></svg>',
    pan: '<svg viewBox="0 0 90 60" width="90" height="60" aria-hidden="true"><ellipse cx="45" cy="42" rx="38" ry="17" fill="#D98C3F"/><path d="M14 40Q30 28 45 38Q60 28 76 40" fill="none" stroke="#B86A26" stroke-width="6" stroke-linecap="round"/><circle cx="45" cy="25" r="7" fill="#B86A26"/><circle cx="28" cy="46" r="1.6" fill="#FFF4E2"/><circle cx="52" cy="48" r="1.6" fill="#FFF4E2"/><circle cx="64" cy="44" r="1.6" fill="#FFF4E2"/></svg>',
    cuenco: '<svg viewBox="0 0 90 52" width="90" height="52" aria-hidden="true"><path d="M8 16h74l-9 30H17z" fill="#00A3A1"/><ellipse cx="45" cy="16" rx="37" ry="7" fill="#8FDCDB"/><circle cx="38" cy="32" r="2" fill="#FFF4E2"/><circle cx="43" cy="29" r="2" fill="#FFF4E2"/><circle cx="49" cy="29" r="2" fill="#FFF4E2"/><circle cx="54" cy="32" r="2" fill="#FFF4E2"/><ellipse cx="46" cy="37" rx="4.5" ry="3.5" fill="#FFF4E2"/></svg>',
    flame: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c1 3 4 4.5 4 8.5a4 4 0 0 1-8 0c0-1.5.7-2.6 1.5-3.3.2 1.5 1 2.3 1.8 2.3C11.3 7 11 4.5 12 2z" fill="#F7941D"/></svg>'
  };

  /* ---------- Utilidades ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
  function fmt(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function txt(tag, cls, text) { var e = el(tag, cls); e.textContent = text == null ? '' : String(text); return e; }
  function img(src, cls) { var i = el('img', cls); i.src = src; i.alt = ''; i.decoding = 'async'; return i; }
  function storageGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function storageSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
  function hash(n) {
    n = (n ^ 61) ^ (n >>> 16); n = n + (n << 3); n = n ^ (n >>> 4);
    n = Math.imul(n, 0x27d4eb2d); n = n ^ (n >>> 15);
    return (n >>> 0) / 4294967295;
  }
  function deviceId() {
    var id = storageGet('pma_device');
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
      storageSet('pma_device', id);
    }
    return id;
  }
  function litSet() {
    try { return JSON.parse(storageGet('pma_lit') || '[]'); } catch (e) { return []; }
  }

  /* ---------- Disposición en anillos alrededor del altar ---------- */
  function ringCells(r) {
    var out = [], x, y;
    for (x = -r; x <= r; x++) out.push([x, -r]);
    for (y = -r + 1; y <= r; y++) out.push([r, y]);
    for (x = r - 1; x >= -r; x--) out.push([x, r]);
    for (y = r - 1; y > -r; y--) out.push([-r, y]);
    return out;
  }
  function reserved(cx, cy) {
    return (Math.abs(cx) <= 1 && Math.abs(cy) <= 1) || (cx === 0 && cy >= 2);
  }
  function buildLayout(count, decoEvery, decoTypes) {
    var slots = [], r = 2, k = 0, placed = 0, decoN = 0, rings = 2;
    if (!decoTypes || !decoTypes.length) decoEvery = 0;
    while ((placed < count || r <= MIN_RINGS) && r < 80) {
      var cells = ringCells(r);
      for (var i = 0; i < cells.length; i++) {
        var cx = cells[i][0], cy = cells[i][1];
        if (reserved(cx, cy)) continue;
        var jx = Math.round(hash(k * 3 + 1) * 20 - 10);
        var jy = Math.round(hash(k * 3 + 2) * 16 - 8);
        var rot = Math.round(hash(k * 3 + 3) * 8 - 4);
        var isDeco = decoEvery > 0 && (k % decoEvery) === 3;
        if (!isDeco && decoEvery > 0 && placed >= count && hash(k + 977) < 0.3) isDeco = true;
        if (isDeco) {
          slots.push({ type: 'deco', deco: decoTypes[decoN % decoTypes.length], x: cx * CELL_W - 55 + jx, y: cy * CELL_H - 60 + jy });
          decoN++;
        } else if (placed < count) {
          slots.push({ type: 'pet', index: placed, x: cx * CELL_W - FRAME_W / 2 + jx, y: cy * CELL_H - FRAME_H / 2 + jy, rot: rot });
          placed++;
        }
        k++;
      }
      rings = r;
      r++;
    }
    return { slots: slots, rings: rings };
  }

  /* ---------- Supabase ---------- */
  function apiBase(cfg) { return String(cfg.supabaseUrl || '').replace(/\/+$/, ''); }
  function imageUrl(cfg, path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return apiBase(cfg) + '/storage/v1/object/public/altar/' + String(path).split('/').map(encodeURIComponent).join('/');
  }
  function fetchPets(cfg) {
    var base = apiBase(cfg) + '/rest/v1/altar_pets?select=id,seq,pet_name,years,dedication,image_path,thumb_path,candles&order=seq.asc';
    var page = 1000, all = [];
    function next(offset) {
      return fetch(base + '&limit=' + page + '&offset=' + offset, { headers: { apikey: cfg.supabaseKey } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (rows) { all = all.concat(rows || []); return (rows && rows.length === page) ? next(offset + page) : all; });
    }
    return next(0);
  }
  function rpc(cfg, fn, body) {
    return fetch(apiBase(cfg) + '/rest/v1/rpc/' + fn, {
      method: 'POST',
      headers: { apikey: cfg.supabaseKey, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return t ? JSON.parse(t) : null; });
  }

  /* =========================================================
     Altar
     ========================================================= */
  function Altar(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-pma-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.t = this.cfg.texts || {};
    this.stage = root.querySelector('[data-pma-stage]');
    this.viewport = root.querySelector('[data-pma-viewport]');
    this.world = root.querySelector('[data-pma-world]');
    this.status = root.querySelector('[data-pma-status]');
    this.ficha = root.querySelector('[data-pma-ficha]');
    this.hint = root.querySelector('[data-pma-hint]');
    this.search = root.querySelector('[data-pma-search]');
    this.searchInput = root.querySelector('[data-pma-search-input]');
    this.results = root.querySelector('[data-pma-results]');
    this.pets = [];
    this.byId = {};
    this.slotById = {};
    this.frameEls = {};
    this.immersive = false;
    this.s = 1; this.tx = 0; this.ty = 0; this.minS = 0.2;
    this.pointers = {};
    this.pointerCount = 0;
    this.lit = litSet();
    this.current = null;
    this.bind();
    this.load();
  }

  Altar.prototype.setStatus = function (text) {
    if (!this.status) return;
    if (text) { this.status.textContent = text; this.status.hidden = false; }
    else { this.status.hidden = true; }
  };

  Altar.prototype.load = function () {
    var self = this;
    if (!this.cfg.supabaseUrl || !this.cfg.supabaseKey) {
      this.setStatus(this.t.error);
      return;
    }
    this.setStatus(this.t.loading);
    fetchPets(this.cfg).then(function (rows) {
      self.pets = rows;
      self.index();
      self.render();
      self.setStatus(rows.length ? '' : self.t.empty);
      self.fitPreview();
      self.openFromUrl();
    }).catch(function (err) {
      console.error('[Altar] Error al cargar:', err);
      self.render();
      self.fitPreview();
      self.setStatus(self.t.error);
    });
  };

  Altar.prototype.index = function () {
    var self = this;
    this.byId = {};
    this.pets.forEach(function (p) { self.byId[p.id] = p; });
  };

  Altar.prototype.totals = function () {
    var velas = 0;
    this.pets.forEach(function (p) { velas += Number(p.candles) || 0; });
    return { peludos: this.pets.length.toLocaleString('es-ES'), velas: velas.toLocaleString('es-ES') };
  };

  Altar.prototype.updateCounters = function () {
    var text = fmt(this.t.counter, this.totals());
    var nodes = this.stage.querySelectorAll('[data-pma-counter]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
    if (this.altarCounter) this.altarCounter.textContent = text;
  };

  /* ---------- Pintar el mundo ---------- */
  Altar.prototype.decoNode = function (key, svgKey) {
    var url = this.cfg.images && this.cfg.images[key];
    if (url) return img(url);
    var wrap = el('span');
    wrap.innerHTML = SVG[svgKey || key] || '';
    return wrap.firstChild || wrap;
  };

  Altar.prototype.florNode = function () {
    var url = this.cfg.images && this.cfg.images.flor;
    return url ? img(url) : el('span', 'pma-marigold');
  };

  Altar.prototype.render = function () {
    var cfg = this.cfg, w = this.world, self = this;
    w.innerHTML = '';
    this.frameEls = {};
    this.slotById = {};
    var decoTypes = [];
    if (cfg.showDecoVelas) decoTypes.push('velas');
    if (cfg.showDecoFlores) decoTypes.push('flores');
    var L = buildLayout(this.pets.length, Number(cfg.decoEvery) || 0, decoTypes);
    var R = L.rings + 0.5;
    var b = this.bounds = { minX: -R * CELL_W, maxX: R * CELL_W, minY: -R * CELL_H - 150, maxY: R * CELL_H + 20 };

    if (cfg.showGlow) w.appendChild(el('div', 'pma-app__glow'));

    if (cfg.showPapel) w.appendChild(this.garland(b));
    if (cfg.showPetals) this.petals(b);

    var colors = (cfg.frameColors && cfg.frameColors.length) ? cfg.frameColors : ['#E4007C'];
    L.slots.forEach(function (s) {
      if (s.type === 'deco') {
        var d = el('div', 'pma-app__deco');
        d.style.left = s.x + 'px';
        d.style.top = s.y + 'px';
        d.appendChild(self.decoNode(s.deco === 'velas' ? 'velas' : 'flores'));
        w.appendChild(d);
        return;
      }
      var pet = self.pets[s.index];
      self.slotById[pet.id] = s;
      var f = self.frame(pet, s, colors[s.index % colors.length]);
      self.frameEls[pet.id] = f;
      w.appendChild(f);
    });

    if (cfg.showArch) {
      for (var k = 0; k <= 18; k++) {
        var a = Math.PI - (Math.PI * k) / 18;
        var ball = el('div', 'pma-app__arch');
        ball.style.left = Math.round(280 * Math.cos(a) - 20) + 'px';
        ball.style.top = Math.round(-280 * Math.sin(a) - 20) + 'px';
        ball.appendChild(this.florNode());
        w.appendChild(ball);
      }
    }

    w.appendChild(this.altar());
    this.updateCounters();
    this.observeImages();
  };

  Altar.prototype.garland = function (b) {
    var cfg = this.cfg;
    var g = el('div', 'pma-app__garland');
    var width = b.maxX - b.minX;
    g.style.left = b.minX + 'px';
    g.style.top = b.minY + 'px';
    g.style.width = width + 'px';
    if (cfg.images && cfg.images.papel) {
      var bar = el('div', 'pma-papel pma-papel--image');
      bar.style.backgroundImage = 'url("' + cfg.images.papel + '")';
      bar.style.setProperty('--pma-papel-img-h', (cfg.papelImageH || 90) + 'px');
      bar.style.setProperty('--pma-flag-scale', '1');
      g.appendChild(bar);
      return g;
    }
    var row = el('div', 'pma-papel');
    row.style.setProperty('--pma-papel-hole', cfg.worldBg || '#24103A');
    row.style.setProperty('--pma-papel-string', cfg.papelString || '#C9A27A');
    row.style.setProperty('--pma-flag-w', '70px');
    row.style.setProperty('--pma-flag-scale', '1');
    var colors = (cfg.papelColors && cfg.papelColors.length) ? cfg.papelColors : ['#E4007C'];
    var n = Math.ceil(width / 76);
    for (var i = 0; i < n; i++) {
      var f = el('span', 'pma-papel__flag');
      f.style.background = colors[i % colors.length];
      f.innerHTML = '<i></i><i></i><i></i><i></i><i></i><i></i>';
      row.appendChild(f);
    }
    g.appendChild(row);
    return g;
  };

  Altar.prototype.petals = function (b) {
    var cfg = this.cfg, w = this.world;
    var url = cfg.images && cfg.images.petalo;
    var count = Number(cfg.petalCount) || 0;
    function add(x, y, rot) {
      var p = url ? img(url, 'pma-app__petal') : el('span', 'pma-app__petal');
      p.style.left = Math.round(x) + 'px';
      p.style.top = Math.round(y) + 'px';
      p.style.transform = 'rotate(' + Math.round(rot) + 'deg)';
      w.appendChild(p);
    }
    for (var i = 0; i < count; i++) {
      var x = b.minX + hash(i * 7 + 11) * (b.maxX - b.minX);
      var y = b.minY + 140 + hash(i * 7 + 13) * (b.maxY - b.minY - 140);
      if (x > -330 && x < 330 && y > -330 && y < 270) continue;
      add(x, y, hash(i * 7 + 17) * 180);
    }
    if (cfg.showPath) {
      for (var j = 0; j * 19 + 270 < b.maxY; j++) {
        add(-46 + hash(j * 5 + 3) * 92, 270 + j * 19, hash(j * 5 + 7) * 180);
      }
    }
  };

  Altar.prototype.frame = function (pet, s, color) {
    var f = el('button', 'pma-app__frame');
    f.type = 'button';
    f.style.left = s.x + 'px';
    f.style.top = s.y + 'px';
    f.style.setProperty('--r', s.rot + 'deg');
    f.style.setProperty('--fc', color);
    f.setAttribute('aria-label', fmt(this.t.frameAria, { nombre: pet.pet_name }));
    f.setAttribute('data-id', pet.id);
    if (!this.immersive) f.tabIndex = -1;

    var paper = el('span', 'pma-app__frame-paper');
    var photo = el('span', 'pma-app__frame-photo');
    var im = el('img');
    im.alt = '';
    im.decoding = 'async';
    im.setAttribute('data-src', imageUrl(this.cfg, pet.thumb_path || pet.image_path));
    im.addEventListener('load', function () { im.classList.add('is-loaded'); });
    photo.appendChild(im);
    paper.appendChild(photo);
    paper.appendChild(txt('span', 'pma-app__frame-name', pet.pet_name));
    var c = null;
    if (this.cfg.showFrameCandles) {
      c = el('span', 'pma-app__frame-candles');
      c.innerHTML = SVG.flame;
      c.appendChild(txt('span', null, (Number(pet.candles) || 0).toLocaleString('es-ES')));
      paper.appendChild(c);
    }
    f.appendChild(paper);
    if (this.cfg.showFrameFlor) {
      var flor = el('span', 'pma-app__frame-flor');
      flor.setAttribute('aria-hidden', 'true');
      flor.appendChild(this.florNode());
      f.appendChild(flor);
    }
    f._img = im;
    f._count = c ? c.lastChild : null;
    return f;
  };

  Altar.prototype.altar = function () {
    var t = this.t, cfg = this.cfg, self = this;
    var images = cfg.images || {};
    var mode = cfg.altarMode || 'drawing';
    if (mode === 'image' && !images.altar) mode = 'drawing';

    var a = el('div', 'pma-app__altar' + (cfg.altarClick === 'story' ? ' is-link' : ''));
    a.setAttribute('aria-hidden', 'true');
    if (cfg.showAltarEyebrow && t.altarEyebrow) a.appendChild(txt('p', 'pma-app__altar-eyebrow', t.altarEyebrow));
    if (cfg.showAltarTitle && t.altarTitle) a.appendChild(txt('p', 'pma-app__altar-title', t.altarTitle));

    this.altarCounter = null;
    var counterInTier = false;

    function item(kind, key, svgKey) {
      var i = el('div', 'pma-app__altar-item pma-app__altar-item--' + kind);
      i.appendChild(self.decoNode(key, svgKey));
      return i;
    }

    if (mode === 'image') {
      var box = el('div', 'pma-app__altar-custom');
      box.appendChild(img(images.altar));
      a.appendChild(box);
    } else if (mode === 'drawing') {
      if (cfg.showAltarVelas || cfg.showAltarFlores) {
        var r1 = el('div', 'pma-app__altar-row');
        if (cfg.showAltarVelas) r1.appendChild(item('vela', 'velaAltar', 'vela'));
        if (cfg.showAltarFlores) r1.appendChild(item('flores', 'flores'));
        if (cfg.showAltarVelas) {
          var v2 = item('vela', 'velaAltar', 'vela');
          v2.style.transform = 'scaleX(-1)';
          r1.appendChild(v2);
        }
        a.appendChild(r1);
      }
      if (cfg.showAltarTiers) {
        a.appendChild(el('div', 'pma-app__tier pma-app__tier--1'));
        a.appendChild(el('div', 'pma-app__fringe pma-app__fringe--1'));
      }
      if (cfg.showAltarPan || cfg.showAltarCuenco) {
        var r2 = el('div', 'pma-app__altar-row pma-app__altar-row--2');
        if (cfg.showAltarPan) r2.appendChild(item('pan', 'pan'));
        if (cfg.showAltarCuenco) r2.appendChild(item('cuenco', 'cuenco'));
        a.appendChild(r2);
      }
      if (cfg.showAltarTiers) {
        a.appendChild(el('div', 'pma-app__tier pma-app__tier--2'));
        a.appendChild(el('div', 'pma-app__fringe pma-app__fringe--2'));
      }
      if (cfg.showAltarFlowerRow) {
        var r3 = el('div', 'pma-app__altar-row pma-app__altar-row--3');
        for (var k = 0; k < 11; k++) {
          var fl = el('div', 'pma-app__altar-item pma-app__altar-item--flor');
          fl.appendChild(this.florNode());
          r3.appendChild(fl);
        }
        a.appendChild(r3);
      }
      if (cfg.showAltarTiers) {
        var tier3 = el('div', 'pma-app__tier pma-app__tier--3');
        if (cfg.showAltarCounter) { this.altarCounter = tier3; counterInTier = true; }
        else tier3.classList.add('is-empty');
        a.appendChild(tier3);
        a.appendChild(el('div', 'pma-app__fringe pma-app__fringe--3'));
      }
    }

    if (cfg.showAltarCounter && !counterInTier) {
      this.altarCounter = el('p', 'pma-app__altar-count');
      a.appendChild(this.altarCounter);
    }
    return a;
  };

  /* ---------- Carga diferida de fotos ---------- */
  Altar.prototype.observeImages = function () {
    if (this.io) this.io.disconnect();
    var frames = this.frameEls;
    var ids = Object.keys(frames);
    function show(imgEl) {
      var src = imgEl.getAttribute('data-src');
      if (src) { imgEl.src = src; imgEl.removeAttribute('data-src'); }
    }
    if (!('IntersectionObserver' in window)) {
      ids.forEach(function (id) { show(frames[id]._img); });
      return;
    }
    this.io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { show(en.target._img); obs.unobserve(en.target); }
      });
    }, { root: this.viewport, rootMargin: '400px' });
    var io = this.io;
    ids.forEach(function (id) { io.observe(frames[id]); });
  };

  /* ---------- Vista: transformaciones ---------- */
  Altar.prototype.size = function () {
    var r = this.viewport.getBoundingClientRect();
    return { w: r.width, h: r.height };
  };

  Altar.prototype.apply = function (animate) {
    var w = this.world;
    if (animate) {
      w.classList.add('is-animating');
      clearTimeout(this._animT);
      this._animT = setTimeout(function () { w.classList.remove('is-animating'); }, 600);
    }
    w.style.transform = 'translate(' + this.tx + 'px,' + this.ty + 'px) scale(' + this.s + ')';
  };

  Altar.prototype.fitScale = function () {
    var z = this.size(), b = this.bounds;
    if (!b) return 0.5;
    return Math.min(z.w / (b.maxX - b.minX), z.h / (b.maxY - b.minY));
  };

  Altar.prototype.fitPreview = function () {
    if (this.immersive || !this.bounds) return;
    var z = this.size();
    var s = Math.min(z.w / (5.6 * CELL_W), z.h / (5.6 * CELL_H));
    this.s = clamp(s, 0.12, 1);
    this.tx = z.w / 2;
    this.ty = z.h / 2 - 30 * this.s;
    this.apply(false);
  };

  Altar.prototype.centerAll = function (animate) {
    var z = this.size(), b = this.bounds;
    if (!b) return;
    var fit = this.fitScale();
    this.minS = Math.max(0.08, fit * 0.85);
    var s = clamp(Math.max(fit, Math.min(z.w / (7 * CELL_W), z.h / (7 * CELL_H))), this.minS, MAX_SCALE);
    this.s = s;
    this.tx = z.w / 2;
    this.ty = z.h / 2;
    this.clampPan();
    this.apply(animate);
  };

  Altar.prototype.clampPan = function () {
    var z = this.size(), b = this.bounds, s = this.s, m = 140;
    if (!b) return;
    var left = this.tx + b.minX * s, right = this.tx + b.maxX * s;
    var top = this.ty + b.minY * s, bottom = this.ty + b.maxY * s;
    if (right < m) this.tx += m - right;
    if (left > z.w - m) this.tx -= left - (z.w - m);
    if (bottom < m) this.ty += m - bottom;
    if (top > z.h - m) this.ty -= top - (z.h - m);
  };

  Altar.prototype.zoomAt = function (px, py, ns, animate) {
    ns = clamp(ns, this.minS, MAX_SCALE);
    var wx = (px - this.tx) / this.s, wy = (py - this.ty) / this.s;
    this.s = ns;
    this.tx = px - wx * ns;
    this.ty = py - wy * ns;
    this.clampPan();
    this.apply(animate);
  };

  Altar.prototype.zoomBy = function (factor) {
    var z = this.size();
    this.zoomAt(z.w / 2, z.h / 2, this.s * factor, true);
  };

  Altar.prototype.focusPet = function (id, animate) {
    var slot = this.slotById[id];
    if (!slot) return;
    var z = this.size();
    var desktop = window.matchMedia('(min-width: 1000px)').matches;
    var ns = clamp(desktop ? 1.4 : 1.1, this.minS, MAX_SCALE);
    var targetX = desktop ? (z.w - 488) / 2 : z.w / 2;
    var targetY = desktop ? z.h / 2 : z.h * 0.28;
    var cx = slot.x + FRAME_W / 2, cy = slot.y + FRAME_H / 2;
    this.s = ns;
    this.tx = targetX - cx * ns;
    this.ty = targetY - cy * ns;
    this.apply(animate !== false);
    this.highlight(id);
  };

  Altar.prototype.highlight = function (id) {
    if (this.highlighted && this.frameEls[this.highlighted]) this.frameEls[this.highlighted].classList.remove('is-highlight');
    this.highlighted = id;
    if (id && this.frameEls[id]) this.frameEls[id].classList.add('is-highlight');
  };

  /* ---------- Pantalla completa ---------- */
  Altar.prototype.enterImmersive = function () {
    if (this.immersive) return;
    this.immersive = true;
    this.placeholder = document.createComment('pma-altar');
    this.stage.parentNode.insertBefore(this.placeholder, this.stage);
    document.body.appendChild(this.stage);
    this.stage.classList.add('is-immersive');
    document.documentElement.classList.add('pma-lock');
    var frames = this.frameEls;
    Object.keys(frames).forEach(function (id) { frames[id].tabIndex = 0; });
    this.centerAll(false);
    this.showHint();
    var close = this.stage.querySelector('[data-pma-close]');
    if (close) close.focus({ preventScroll: true });
  };

  Altar.prototype.exitImmersive = function () {
    if (!this.immersive) return;
    this.closeFicha();
    this.closeSearch();
    this.immersive = false;
    this.stage.classList.remove('is-immersive');
    if (this.placeholder && this.placeholder.parentNode) {
      this.placeholder.parentNode.insertBefore(this.stage, this.placeholder);
      this.placeholder.parentNode.removeChild(this.placeholder);
    }
    document.documentElement.classList.remove('pma-lock');
    var frames = this.frameEls;
    Object.keys(frames).forEach(function (id) { frames[id].tabIndex = -1; });
    this.highlight(null);
    this.fitPreview();
    this.clearUrl();
  };

  Altar.prototype.showHint = function () {
    var h = this.hint;
    if (!h) return;
    h.classList.remove('is-hidden');
    clearTimeout(this._hintT);
    this._hintT = setTimeout(function () { h.classList.add('is-hidden'); }, 5000);
  };

  /* ---------- Ficha ---------- */
  Altar.prototype.openFicha = function (id) {
    var pet = this.byId[id];
    if (!pet || !this.ficha) return;
    this.current = pet;
    var f = this.ficha, t = this.t;
    var photo = f.querySelector('[data-pma-f-photo]');
    var photoBg = f.querySelector('[data-pma-f-photo-bg]');
    var box = f.querySelector('[data-pma-f-photo-box]');
    var src = imageUrl(this.cfg, pet.image_path || pet.thumb_path);
    /* Marco según la foto: vertical 4:5 (por defecto), horizontal 4:3, cuadrada 1:1. La foto se ve completa. */
    function fitBox() {
      if (!box) return;
      var w = photo.naturalWidth, h = photo.naturalHeight;
      box.classList.remove('is-landscape', 'is-square');
      if (!w || !h) return;
      var r = w / h;
      if (r > 1.05) box.classList.add('is-landscape');
      else if (r >= 0.95) box.classList.add('is-square');
    }
    if (box) box.classList.remove('is-landscape', 'is-square');
    photo.onload = fitBox;
    if (photoBg) photoBg.src = src;
    photo.src = src;
    if (photo.complete && photo.naturalWidth) fitBox();
    photo.alt = fmt(t.photoAlt, { nombre: pet.pet_name });
    f.querySelector('[data-pma-f-name]').textContent = pet.pet_name;
    f.querySelector('[data-pma-f-years]').textContent = pet.years || '';
    f.querySelector('[data-pma-f-ded]').textContent = pet.dedication ? '\u201C' + pet.dedication + '\u201D' : '';
    this.paintCandle();
    var copy = f.querySelector('[data-pma-f-copy-label]');
    if (copy) copy.textContent = t.copy;
    var rep = f.querySelector('[data-pma-f-report]');
    rep.disabled = false;
    rep.textContent = t.report;
    f.hidden = false;
    this.focusPet(id, true);
    this.setUrl(id);
    var closeBtn = f.querySelector('[data-pma-f-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  };

  Altar.prototype.closeFicha = function () {
    if (!this.ficha || this.ficha.hidden) return;
    this.ficha.hidden = true;
    this.highlight(null);
    this.current = null;
    this.clearUrl();
  };

  Altar.prototype.paintCandle = function () {
    var pet = this.current;
    if (!pet) return;
    var f = this.ficha, t = this.t;
    var lit = this.lit.indexOf(pet.id) !== -1;
    var btn = f.querySelector('[data-pma-f-candle]');
    btn.classList.toggle('is-lit', lit);
    btn.setAttribute('aria-pressed', lit ? 'true' : 'false');
    f.querySelector('[data-pma-f-candle-label]').textContent = lit ? t.candleLit : t.candle;
    f.querySelector('[data-pma-f-count]').textContent = fmt(t.candleCount, { velas: (Number(pet.candles) || 0).toLocaleString('es-ES'), nombre: pet.pet_name });
  };

  Altar.prototype.lightCandle = function () {
    var pet = this.current, self = this;
    if (!pet || this.lit.indexOf(pet.id) !== -1 || this._lighting) return;
    this._lighting = true;
    pet.candles = (Number(pet.candles) || 0) + 1;
    this.lit.push(pet.id);
    storageSet('pma_lit', JSON.stringify(this.lit));
    this.paintCandle();
    this.updateFrameCount(pet);
    this.updateCounters();
    rpc(this.cfg, 'light_candle', { p_pet_id: pet.id, p_device_id: deviceId() }).then(function (n) {
      if (typeof n === 'number') { pet.candles = n; self.paintCandle(); self.updateFrameCount(pet); self.updateCounters(); }
    }).catch(function (err) {
      console.error('[Altar] Error al encender la vela:', err);
    }).then(function () { self._lighting = false; });
  };

  Altar.prototype.updateFrameCount = function (pet) {
    var f = this.frameEls[pet.id];
    if (f && f._count) f._count.textContent = (Number(pet.candles) || 0).toLocaleString('es-ES');
  };

  Altar.prototype.report = function () {
    var pet = this.current, f = this.ficha, t = this.t;
    if (!pet) return;
    if (!window.confirm(t.reportConfirm)) return;
    var rep = f.querySelector('[data-pma-f-report]');
    rep.disabled = true;
    rep.textContent = t.reportDone;
    rpc(this.cfg, 'report_pet', { p_pet_id: pet.id, p_device_id: deviceId() }).catch(function (err) {
      console.error('[Altar] Error al reportar:', err);
    });
  };

  Altar.prototype.petUrl = function (id) {
    return window.location.origin + window.location.pathname + '?peludo=' + encodeURIComponent(id);
  };

  Altar.prototype.copyLink = function () {
    var pet = this.current, label = this.ficha.querySelector('[data-pma-f-copy-label]'), t = this.t;
    if (!pet) return;
    var url = this.petUrl(pet.id);
    function done() { if (label) label.textContent = t.copied; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
    } else {
      window.prompt('', url);
    }
  };

  Altar.prototype.share = function () {
    var pet = this.current, t = this.t;
    if (!pet) return;
    var url = this.petUrl(pet.id);
    if (navigator.share) {
      navigator.share({ title: pet.pet_name, text: fmt(t.shareText, { nombre: pet.pet_name }), url: url }).catch(function () { /* cancelado */ });
    } else {
      this.copyLink();
    }
  };

  /* ---------- URL (enlace directo) ---------- */
  Altar.prototype.setUrl = function (id) {
    try { history.replaceState(history.state, '', this.petUrl(id)); } catch (e) { /* nada */ }
  };
  Altar.prototype.clearUrl = function () {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('peludo')) { u.searchParams.delete('peludo'); history.replaceState(history.state, '', u.toString()); }
    } catch (e) { /* nada */ }
  };
  Altar.prototype.openFromUrl = function () {
    var id;
    try { id = new URL(window.location.href).searchParams.get('peludo'); } catch (e) { id = null; }
    if (!id) return;
    if (this.byId[id]) {
      this.enterImmersive();
      this.openFicha(id);
    } else {
      this.clearUrl();
    }
  };

  /* ---------- Buscador ---------- */
  Altar.prototype.openSearch = function () {
    if (!this.search) return;
    this.search.classList.add('is-open');
    this.searchInput.focus();
  };
  Altar.prototype.closeSearch = function () {
    if (!this.search) return;
    this.search.classList.remove('is-open');
    this.results.hidden = true;
  };
  Altar.prototype.runSearch = function () {
    var q = norm(this.searchInput.value), res = this.results, self = this;
    res.innerHTML = '';
    if (q.length < 2) { res.hidden = true; return; }
    var found = this.pets.filter(function (p) { return norm(p.pet_name).indexOf(q) !== -1; }).slice(0, 8);
    if (!found.length) {
      var li0 = el('li');
      li0.appendChild(txt('p', null, this.t.noResults));
      res.appendChild(li0);
    }
    found.forEach(function (p) {
      var li = el('li');
      var b = txt('button', null, p.pet_name + (p.years ? ' · ' + p.years : ''));
      b.type = 'button';
      b.addEventListener('click', function () {
        self.closeSearch();
        self.searchInput.value = '';
        self.openFicha(p.id);
      });
      li.appendChild(b);
      res.appendChild(li);
    });
    res.hidden = false;
  };

  /* ---------- Ir a la sección Historia (clic en el altar central desde la vista previa) ---------- */
  Altar.prototype.goToStory = function () {
    var target = document.querySelector('.pma-story');
    if (!target) return false;
    var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, top); }
    return true;
  };

  /* ---------- API pública (la usará el formulario del paso 5) ---------- */
  Altar.prototype.addPet = function (pet) {
    if (!pet || !pet.id || this.byId[pet.id]) return;
    this.pets.push(pet);
    this.index();
    this.render();
    this.setStatus('');
    if (this.immersive) this.centerAll(false); else this.fitPreview();
  };

  /* ---------- Eventos ---------- */
  Altar.prototype.bind = function () {
    var self = this, vp = this.viewport, root = this.stage;

    vp.addEventListener('click', function (e) {
      if (self._justDragged) return;
      var frame = e.target.closest('.pma-app__frame');
      if (!self.immersive) {
        if (!frame && self.cfg.altarClick === 'story' && e.target.closest('.pma-app__altar') && self.goToStory()) return;
        self.enterImmersive();
        if (frame) self.openFicha(frame.getAttribute('data-id'));
        return;
      }
      if (frame) self.openFicha(frame.getAttribute('data-id'));
    });

    vp.addEventListener('pointerdown', function (e) {
      if (!self.immersive) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      self.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      self.pointerCount = Object.keys(self.pointers).length;
      if (self.pointerCount === 1) {
        self.drag = { x: e.clientX, y: e.clientY, tx: self.tx, ty: self.ty, moved: false, id: e.pointerId };
      } else if (self.pointerCount === 2) {
        var p = self.twoPointers();
        self.pinch = { d: p.d, mx: p.mx, my: p.my, s: self.s, tx: self.tx, ty: self.ty };
        if (self.drag) self.drag.moved = true;
        try { vp.setPointerCapture(e.pointerId); } catch (err) { /* nada */ }
      }
    });

    vp.addEventListener('pointermove', function (e) {
      if (!self.immersive || !self.pointers[e.pointerId]) return;
      self.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var rect = vp.getBoundingClientRect();
      if (self.pointerCount >= 2 && self.pinch) {
        var p = self.twoPointers();
        var ns = clamp(self.pinch.s * (p.d / self.pinch.d), self.minS, MAX_SCALE);
        var wx = (self.pinch.mx - rect.left - self.pinch.tx) / self.pinch.s;
        var wy = (self.pinch.my - rect.top - self.pinch.ty) / self.pinch.s;
        self.s = ns;
        self.tx = (p.mx - rect.left) - wx * ns;
        self.ty = (p.my - rect.top) - wy * ns;
        self.clampPan();
        self.apply(false);
        return;
      }
      var d = self.drag;
      if (!d) return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!d.moved && Math.abs(dx) + Math.abs(dy) > DRAG_THRESHOLD) {
        d.moved = true;
        root.classList.add('is-dragging');
        try { vp.setPointerCapture(d.id); } catch (err) { /* nada */ }
      }
      if (d.moved) {
        self.tx = d.tx + dx;
        self.ty = d.ty + dy;
        self.clampPan();
        self.apply(false);
      }
    });

    function up(e) {
      if (!self.pointers[e.pointerId]) return;
      delete self.pointers[e.pointerId];
      self.pointerCount = Object.keys(self.pointers).length;
      if (self.pointerCount < 2) self.pinch = null;
      if (self.pointerCount === 0) {
        var moved = self.drag && self.drag.moved;
        self.drag = null;
        root.classList.remove('is-dragging');
        if (moved) {
          self._justDragged = true;
          setTimeout(function () { self._justDragged = false; }, 0);
        }
      } else if (self.pointerCount === 1) {
        var id = Object.keys(self.pointers)[0], pt = self.pointers[id];
        self.drag = { x: pt.x, y: pt.y, tx: self.tx, ty: self.ty, moved: true, id: Number(id) };
      }
    }
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);

    vp.addEventListener('wheel', function (e) {
      if (!self.immersive) return;
      e.preventDefault();
      var rect = vp.getBoundingClientRect();
      var factor = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0015));
      self.zoomAt(e.clientX - rect.left, e.clientY - rect.top, self.s * factor, false);
    }, { passive: false });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pma-action]');
      if (!t) return;
      var a = t.getAttribute('data-pma-action');
      if (a === 'enter') { e.preventDefault(); self.enterImmersive(); }
      else if (a === 'close') self.exitImmersive();
      else if (a === 'zoom-in') self.zoomBy(1.35);
      else if (a === 'zoom-out') self.zoomBy(1 / 1.35);
      else if (a === 'center') { self.closeFicha(); self.centerAll(true); }
      else if (a === 'search') { if (self.search.classList.contains('is-open')) self.closeSearch(); else self.openSearch(); }
      else if (a === 'ficha-close') self.closeFicha();
      else if (a === 'candle') self.lightCandle();
      else if (a === 'copy') self.copyLink();
      else if (a === 'share') self.share();
      else if (a === 'report') self.report();
    });

    if (this.ficha) {
      this.ficha.addEventListener('click', function (e) { if (e.target === self.ficha) self.closeFicha(); });
    }

    if (this.searchInput) {
      this.searchInput.addEventListener('input', function () { self.runSearch(); });
      this.searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var first = self.results.querySelector('button');
          if (first) { e.preventDefault(); first.click(); }
        }
      });
    }

    this._onKey = function (e) {
      if (!self.immersive || e.key !== 'Escape') return;
      if (self.search && self.search.classList.contains('is-open') && !self.results.hidden) { self.closeSearch(); return; }
      if (self.ficha && !self.ficha.hidden) { self.closeFicha(); return; }
      self.exitImmersive();
    };
    document.addEventListener('keydown', this._onKey);

    this._onResize = function () {
      if (self.immersive) { self.clampPan(); self.apply(false); } else { self.fitPreview(); }
    };
    window.addEventListener('resize', this._onResize);
  };

  Altar.prototype.twoPointers = function () {
    var ids = Object.keys(this.pointers);
    var a = this.pointers[ids[0]], b = this.pointers[ids[1]];
    return { d: Math.max(1, Math.hypot(b.x - a.x, b.y - a.y)), mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
  };

  Altar.prototype.destroy = function () {
    this.exitImmersive();
    document.removeEventListener('keydown', this._onKey);
    window.removeEventListener('resize', this._onResize);
    if (this.io) this.io.disconnect();
  };

  /* =========================================================
     Arranque
     ========================================================= */
  var instances = [];

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pma-altar]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]._pmaAltar) continue;
      try {
        nodes[i]._pmaAltar = new Altar(nodes[i]);
        instances.push(nodes[i]._pmaAltar);
      } catch (err) {
        console.error('[Altar] No se pudo iniciar:', err);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pma-open]');
    if (!t) return;
    var action = t.getAttribute('data-pma-open');
    var inst = instances[0];
    if (action === 'altar') {
      e.preventDefault();
      if (inst) inst.enterImmersive();
    } else if (action === 'form') {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('pma:open-form'));
    }
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var node = e.target.querySelector('[data-pma-altar]');
    if (node && node._pmaAltar) {
      node._pmaAltar.destroy();
      var idx = instances.indexOf(node._pmaAltar);
      if (idx !== -1) instances.splice(idx, 1);
      node._pmaAltar = null;
    }
  });

  window.PMAltar = {
    open: function () { if (instances[0]) instances[0].enterImmersive(); },
    add: function (pet) { if (instances[0]) instances[0].addPet(pet); },
    show: function (id) { var a = instances[0]; if (a && a.byId[id]) { a.enterImmersive(); a.openFicha(id); } },
    instances: instances
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();